<template>
    <div style="margin-left: auto; margin-right: auto; width: 100%; position: relative" id="commonFront">
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 642 642" style="enable-background:new 0 0 642 642;" xml:space="preserve">
<g>
	<g>
		<path class="body" d="M140.79,152.27c3.07-4.74,7.46-7.95,12.06-10.81c8.58-5.44,17.36-10.25,27.68-11.64
			c1.05-0.14,2.09-0.42,3-0.91c18.96-9.34,39.67-14.36,59.06-22.59c3.63-1.53,7.18-3.21,10.6-5.3c-0.35,2.86-1.46,5.79,0.56,8.37
			c9.48,12.27,20.22,22.94,36.05,26.56c3.77,2.3,8.09,2.58,12.34,3.35c6.14,1.05,6.14,1.05,6.83,7.32c0.07,0.56,0.21,1.12,0.35,1.67
			c2.79,12.34,5.58,24.61,8.37,36.95c0.7,3.07,1.32,6.14,2.02,9.13c2.23-5.65,3.7-11.36,5.09-17.08
			c2.44-10.25,3.49-20.85,7.95-30.54c1.53-3.42,3.21-6.41,7.81-6.07c1.19,0.07,2.37-0.7,3.63-1.12c1.39-0.07,2.79,0,4.11-0.21
			c19.59-3.77,37.09-25.59,32.98-44.55c12.13,9.34,26.98,12.9,40.65,18.9s27.68,11.09,41.56,16.73c4.6,1.88,9.27,3.56,14.01,5.02
			c8.72,2.72,16.32,7.6,23.5,13.18c1.6,1.26,2.79,2.79,3.7,4.6c0.07,13.39-3.56,26.15-6.07,39.11c-6,30.75-13.18,61.29-20.29,91.76
			c-1.19,5.23-2.09,10.53-4.95,15.13c-3.7,6-5.02,12.69-5.86,19.52c-2.16,3.21-2.23,7.04-2.51,10.67
			c-0.63,8.72,0.56,17.36,0.63,26.08c0.07,14.01,0.21,28.1-0.21,42.11c-0.28,10.39,1.67,20.57,2.65,30.82
			c3.14,32.63-0.28,64.35-13.53,94.68c-2.79,6.41-7.88,10.46-13.6,13.94c-0.7,0.35-1.46,0.7-2.16,1.12
			c-7.95,4.46-16.11,7.95-25.52,8.09c-17.36,0.21-34.72,0.7-52.01,2.65c-5.23,0.56-5.51,0.63-5.51,5.79
			c0.07,14.99,0.28,29.91,0.35,44.9c-12.06,1.88-24.19,2.09-36.33,2.37c-2.86,0.07-5.93,0.77-8.65,0.21
			c-6.48-1.32-13.04-1.74-19.66-2.16c-5.79-0.35-11.57,0.21-17.29-0.84c0-15.06-0.14-30.19-0.07-45.25c0-2.3-0.28-3.77-3.07-3.83
			c-11.92-0.21-23.92-1.26-35.77-2.72c-12.41-1.53-24.82-3.35-35.77-10.25c-6.28-4.39-10.18-10.32-11.71-17.85
			c-1.12-5.51-3.9-10.39-6.14-15.48c-1.74-3.83-3.14-7.81-3.35-11.99c-0.42-7.81-2.02-15.41-3.97-22.94
			c-3.83-14.64-2.58-29.28-0.42-43.86c2.65-18.06,4.39-36.12,4.88-54.38c0.35-13.67-1.26-27.33-1.6-41
			c-0.07-2.86-1.19-5.65-1.81-8.51c0.42-2.37-0.14-4.6-1.19-6.69c-1.67-3.35-2.65-6.97-3.14-10.67
			c-2.65-20.15-7.53-39.88-11.78-59.68C152.58,213.49,144.21,183.37,140.79,152.27z M458.52,468.75c-3-18.96-4.39-39.39-9.06-59.33
			c-3.63-15.62-7.53-31.1-11.09-46.71c-1.88-8.23-1.67-8.23-9.2-4.25c-1.74,0.91-2.37,1.95-1.74,3.83
			c5.44,17.99,9.41,36.4,13.81,54.59c3.14,12.97,7.18,25.73,8.72,38.98c0.7,6.14,0.84,12.27,1.32,18.41
			c0.07,1.19-0.28,2.93,1.74,2.58C455.6,476.56,458.66,472.51,458.52,468.75z M183.32,469.44c-0.91,3.42,2.93,4.53,4.74,6.83
			c0.49,0.63,1.12,1.39,2.02,1.05c0.91-0.42,0.63-1.39,0.63-2.16c-0.14-4.04-0.07-8.16,0.35-12.2c1.81-17.22,6-34.03,9.83-50.83
			c3.77-16.52,7.95-32.91,12.9-49.16c0.35-1.12,1.39-3.14,0-3.42c-3.07-0.63-5.3-3.35-8.58-3.07c-0.42,0-0.84,1.05-1.05,1.67
			c-0.49,1.32-0.98,2.65-1.32,3.97c-3.14,13.18-6.21,26.43-9.27,39.6C188.41,423.85,186.25,446.37,183.32,469.44z M296.83,149.41
			c-3.14,0.07-5.65,2.72-5.58,5.86c0.07,3,2.65,5.44,5.65,5.44c3.21,0,5.86-2.65,5.79-5.65
			C302.62,151.99,299.9,149.34,296.83,149.41z M322.91,426.22c-2.86-0.07-5.58,2.51-5.58,5.44c0,2.93,2.23,5.37,5.16,5.51
			c2.86,0.21,5.72-2.37,5.93-5.23C328.49,429.14,325.77,426.29,322.91,426.22z M323.68,559.18c-0.07-2.93-2.79-5.51-5.65-5.44
			c-2.79,0.14-5.37,2.72-5.37,5.44c-0.07,2.79,2.72,5.58,5.58,5.58S323.75,562.04,323.68,559.18z M321.66,237.96
			c-2.86,0-5.65,2.79-5.58,5.58c0.07,2.72,2.72,5.3,5.44,5.37c2.86,0.07,5.65-2.58,5.65-5.44
			C327.23,240.61,324.58,237.96,321.66,237.96z M326.54,336.76c0-2.93-2.37-5.3-5.3-5.37c-3.07-0.07-5.58,2.44-5.58,5.51
			c0.07,2.93,2.44,5.37,5.3,5.44C323.96,342.34,326.61,339.76,326.54,336.76z M317.47,580.17c-2.86,0-5.65,2.72-5.58,5.51
			c0.07,2.86,2.86,5.51,5.72,5.44c2.65-0.07,5.37-2.79,5.37-5.44C322.98,582.82,320.4,580.17,317.47,580.17z M324.72,521.18
			c0-2.93-2.23-5.23-5.3-5.3c-3.21-0.07-5.58,2.16-5.58,5.3c0,2.93,2.3,5.23,5.3,5.3C322.21,526.62,324.65,524.25,324.72,521.18z
			 M350.1,154.08c0.14-2.86-2.23-5.3-5.09-5.44c-3.28-0.14-5.58,1.95-5.65,5.16c-0.07,2.86,2.3,5.3,5.23,5.3
			C347.52,159.17,350.03,156.94,350.1,154.08z"/>
		<path class="sleeve" d="M467.31,318.77c0.84-6.83,2.09-13.46,5.86-19.52c2.86-4.6,3.77-9.97,4.95-15.13
			c7.11-30.54,14.29-61.01,20.29-91.76c2.51-12.97,6.14-25.73,6.07-39.11c6.9,8.99,12.27,18.9,17.01,29.07
			c7.32,15.69,14.5,31.38,20.99,47.41c13.25,32.28,27.33,64.29,38,97.61c1.74,5.44,3.28,10.88,3.63,16.59
			c0.42,6.76,2.86,12.9,5.58,18.9c1.81,3.97,2.79,8.02,2.65,12.48c-0.21,5.16,1.95,9.97,2.79,14.99c1.05,6.07,0.49,12.27,1.05,18.41
			c1.05,11.78,3.14,23.43,4.74,35.07c1.26,8.79,1.53,17.71,1.39,26.63c-0.21,16.73,0.28,33.4,0.56,50.13c0,2.58-0.14,5.09-0.77,7.6
			c-1.32,5.23-3.56,10.25-4.53,15.62c-0.98,5.79-5.23,9.34-9.9,12.34c-8.65,2.09-17.43,3.28-26.29,3.7
			c-10.67,0.42-21.27-0.49-31.03-5.44c-3.7-2.79-6.41-6.34-8.02-10.6c-0.91-2.58-2.58-4.67-3.7-7.11c-3.42-7.46-6-15.2-6.14-23.43
			c-0.21-10.39-3.21-20.08-5.79-29.98c-4.18-16.25-6.9-32.91-11.16-49.22c-2.37-9.13-5.44-17.99-8.72-26.77
			c-5.79-15.55-8.92-31.72-10.74-48.11c-1.32-12.13-5.09-23.57-7.46-35.35C468.28,322.12,467.73,320.45,467.31,318.77z"/>
		<path class="sleeve" d="M140.79,152.27c3.49,31.1,11.78,61.22,18.34,91.69c4.25,19.8,9.2,39.53,11.78,59.68
			c0.49,3.7,1.46,7.25,3.14,10.67c1.05,2.09,1.6,4.32,1.19,6.69c-3.42,5.02-6.48,10.32-7.18,16.39c-1.12,9.48-3.63,18.69-6.14,27.82
			c-2.72,10.11-3.28,20.57-5.65,30.75c-3.07,13.53-6.48,26.98-10.04,40.37c-4.6,17.29-7.46,35.07-9.83,52.85
			c-1.05,7.67-1.81,15.41-2.72,23.08c-0.77,6.76-3.77,12.9-6,19.17c-1.26,3.49-2.86,6.83-4.04,10.39
			c-1.67,4.88-4.46,8.85-8.72,11.85c-0.28,0.28-0.49,0.49-0.77,0.77h0.07c-1.26-0.21-2.23,0.49-3.28,0.84
			c-5.02,1.67-10.04,3.7-15.34,3.9c-14.5,0.49-29.07,0.63-42.81-5.51c-7.6-6.55-9.48-15.48-10.39-24.96
			c-2.02-21.2-1.95-42.53-0.35-63.66c1.81-24.26,4.18-48.46,7.46-72.65c3.63-26.63,10.81-52.22,18.41-77.74
			c2.44-8.23,7.11-15.62,10.04-23.71c11.3-31.03,25.45-60.8,38.77-90.99c5.23-11.92,10.04-23.98,16.04-35.56
			C135.08,160.22,137.45,155.9,140.79,152.27z"/>
		<path class="solid" d="M289.72,136.03c-15.83-3.7-26.56-14.29-36.05-26.56c-2.02-2.65-0.91-5.58-0.56-8.37
			c4.6-9.48,8.02-19.52,13.18-28.73c3.7-6.55,8.58-9.9,16.39-10.04c21.82-0.35,43.58-0.35,65.33-0.35c2.3,0,4.6,0.28,6.9,0.56
			c7.74,0.91,13.32,4.6,16.52,11.99c3,6.9,6.34,13.67,9.55,20.5c4.11,18.96-13.39,40.79-32.98,44.55c-1.32,0.28-2.79,0.14-4.11,0.21
			c0-12.76,3.9-24.75,8.44-36.95c-3.07,0.49-5.58,0.98-8.09,1.26c-2.65,0.28-5.3,0.42-7.95,0.7c-2.37,0.28-3.77-0.63-4.88-2.79
			c-1.88-3.63-4.25-6.9-8.65-8.02c-7.6-1.95-12.55-0.07-17.01,6.28c-0.42,0.56-0.91,1.12-1.19,1.67c-0.91,1.81-2.37,2.23-4.32,2.16
			c-4.18-0.21-8.37-0.28-12.48-0.35c-4.81-0.07-4.6-0.14-3.14,4.39C287.63,117.13,289.16,126.47,289.72,136.03z"/>
		<path class="solid" d="M356.03,599.48c-0.14-14.99-0.28-29.91-0.35-44.9c0-5.09,0.28-5.23,5.51-5.79
			c17.29-1.88,34.65-2.37,52.08-2.65c9.41-0.14,17.57-3.56,25.52-8.09c0.7-0.42,1.39-0.7,2.16-1.12c0.35,10.67,0.7,21.34,1.05,31.93
			c0.07,2.58-1.32,4.39-2.72,6.28c-6.28,8.65-14.71,14.29-25.03,16.32C394.94,595.44,375.48,597.67,356.03,599.48z"/>
		<path class="solid" d="M199.36,537.01c10.95,6.9,23.36,8.79,35.77,10.25c11.85,1.39,23.78,2.44,35.77,2.72
			c1.05,0,3.07,0.14,3.07,0.14s0,2.23,0,3.7c-0.07,15.06,0,30.19,0.07,45.25c-8.51,0.63-16.8-0.77-25.17-2.16
			c-9.69-1.67-19.24-4.11-28.38-7.74c-6.62-2.65-12.76-6-17.64-11.43c-2.86-3.21-5.02-6.76-4.53-11.23
			C199.5,556.74,199.43,546.84,199.36,537.01z"/>
		<path class="solid" d="M52.87,553.67c13.74,6.14,28.24,6,42.81,5.51c5.3-0.21,10.32-2.23,15.34-3.9c1.12-0.35,2.02-1.12,3.28-0.84
			c-2.02,8.3-3.77,16.66-4.67,25.24c-0.63,5.51-1.32,11.09-0.91,16.66c0.21,3.35-1.12,5.23-3.9,6.55
			c-5.02,2.37-10.39,3.21-15.83,3.63c-7.18,0.56-14.36,0.42-21.54-0.42c-1.95-0.21-3.83-0.91-5.65-1.53c-2.65-1.05-3.14-2.65-3-5.65
			C59.56,583.44,60.75,567.89,52.87,553.67z"/>
		<path class="solid" d="M530.27,554.37c9.76,4.95,20.36,5.93,31.03,5.44c8.85-0.35,17.64-1.53,26.29-3.7
			c-2.58,11.57-4.11,23.29-4.81,35.07c-0.14,2.23-0.56,4.46-0.28,6.62c0.49,3.97-1.74,5.3-5.02,6.07
			c-5.58,1.32-11.3,1.19-16.94,0.98c-6.97-0.21-13.88-0.63-20.36-3.77c-5.16-2.51-5.16-2.86-5.09-8.65
			c0.21-12.13-0.56-24.12-4.25-35.77C530.55,555.97,530.48,555.14,530.27,554.37z"/>
		<path class="solid" d="M114.23,554.37c0.28-0.28,0.49-0.49,0.77-0.77C114.93,554.09,114.79,554.44,114.23,554.37z"/>
		<path class="pocket" d="M458.52,468.75c0.14,3.77-2.93,7.81-5.58,8.23c-2.02,0.35-1.67-1.46-1.74-2.58
			c-0.42-6.14-0.63-12.27-1.32-18.41c-1.53-13.32-5.58-26.08-8.72-38.98c-4.39-18.27-8.44-36.6-13.81-54.59
			c-0.56-1.95,0.07-2.93,1.74-3.83c7.53-3.97,7.32-3.97,9.2,4.25c3.63,15.62,7.53,31.1,11.09,46.71
			C454.13,429.42,455.53,449.78,458.52,468.75z"/>
		<path class="pocket" d="M183.32,469.44c2.86-23.08,5.09-45.6,10.18-67.7c3.07-13.25,6.21-26.43,9.27-39.6
			c0.35-1.32,0.77-2.65,1.32-3.97c0.28-0.63,0.7-1.67,1.05-1.67c3.28-0.28,5.51,2.51,8.58,3.07c1.39,0.28,0.35,2.23,0,3.42
			c-4.95,16.25-9.13,32.63-12.9,49.16c-3.83,16.87-8.09,33.61-9.83,50.83c-0.42,4.04-0.49,8.09-0.35,12.2
			c0.07,0.77,0.28,1.74-0.63,2.16s-1.53-0.42-2.02-1.05C186.32,473.98,182.49,472.86,183.32,469.44z"/>
		<path class="solid" d="M318.03,104.23c-2.3,0-4.67,0.14-6.97-0.07c-1.19-0.07-3.07,0.91-3.21-1.46c-0.07-1.81,0.21-3.49,2.3-4.11
			c4.53-1.39,9.13-1.12,13.74-0.35c2.02,0.35,4.6,0.14,4.39,3.56c-0.07,1.74-0.49,2.58-2.37,2.44
			C323.33,104.09,320.68,104.23,318.03,104.23z"/>
	</g>
	<g>
		<path class="single_stripe" d="M355.61,582.05c0-5.65,0-11.3,0-17.01c3.21-0.28,6.48-0.7,9.69-0.91c14.71-0.98,29.42-1.39,44-3.63
			c12.62-1.95,24.19-5.86,31.52-17.43c0.49,5.09,0.49,10.11,0.35,15.2c-1.67,2.51-3.07,5.16-5.23,7.32
			c-7.18,7.18-16.45,9.69-25.94,11.64c-10.74,2.16-21.61,2.65-32.49,3.49C370.18,581.35,362.93,581.63,355.61,582.05z"/>
		<path class="single_stripe" d="M273.97,565.45c0.21,5.72-0.07,11.57,0.07,17.29c-18.55-0.84-36.81-2.51-54.52-8.72
			c-8.3-2.93-15.76-7.32-20.5-15.06c0.14-5.16,0.42-10.32,0.56-15.48c5.44,7.6,13.11,11.78,21.82,14.5
			C238.48,563.29,256.26,564.55,273.97,565.45z"/>
		<path class="single_stripe" d="M58.87,571.87c10.6,4.18,21.68,4.32,32.84,3.77c6.48-0.35,12.83-1.67,18.9-4.11
			c-0.63,5.37-1.26,10.74-1.88,16.11c-7.88,3-16.11,3.97-24.4,4.67c-8.58,0.7-16.87,0.21-24.82-3.21
			C59.29,583.37,59.08,577.59,58.87,571.87z"/>
		<path class="single_stripe" d="M534.1,570.47c16.73,5.93,33.61,6.07,50.55,0.98c-0.28,5.44-0.84,10.88-1.67,16.32
			c-1.95,0.7-3.83,1.6-5.86,2.09c-9.62,2.23-19.24,1.81-28.94,0.42c-4.6-0.7-9.06-1.81-12.97-4.53
			C534.87,580.58,534.45,575.56,534.1,570.47z"/>
		<path class="single_stripe" d="M353.45,137.35c4.46-15.76,10.39-31.03,13.6-47.13c1.05-5.3,2.23-10.67,4.32-15.76
			c2.02,3.49,4.32,6.9,5.02,11.09c-1.32,9.97-2.72,19.94-5.79,29.63c-1.6,5.16-3.28,10.39-4.88,15.55
			C362.37,134.35,358.12,136.24,353.45,137.35z"/>
		<path class="single_stripe" d="M263.44,78.3c2.58,13.11,6.83,25.73,11.16,38.35c1.88,5.37,3.9,10.67,5.86,16.04
			c-5.51-1.53-9.27-5.65-13.46-9.2c-0.35-1.12-0.63-2.23-1.05-3.28c-3.49-8.92-9.55-26.56-9.06-27.4
			C258.28,87.71,260.72,82.9,263.44,78.3z"/>
	</g>
	<g>
		<path class="double_stripe" d="M441.02,546.63c-3.63,9.62-11.78,13.53-20.71,16.25c-13.74,4.11-28.03,4.6-42.18,5.58
			c-6.21,0.42-12.48,0.7-18.69,1.32c-1.32,0.14-3.77,0-3.77,0s0-1.67,0-3.21c0.07-4.6,0-7.74,0.07-8.16c0,0,0-0.07,0.07-0.07
			c0.49-0.07,5.23-0.91,8.79-1.12c14.64-0.91,29.42-0.84,44-3.14c8.02-1.26,15.83-3.14,22.8-7.67c3.21-2.09,6-4.6,7.67-8.16
			l-0.07,0.07c0.56-0.14,0.77-0.49,0.77-1.05h0.14c1.81,0.35,1.12,1.74,1.12,2.79C441.09,542.31,441.02,544.47,441.02,546.63z"/>
		<path class="double_stripe" d="M273.97,558.97c0,3.9,0,7.95,0,11.85c-0.91,0.07-2.02,0.07-2.93,0c-7.67-0.35-15.27-1.05-22.8-2.09
			c-13.67-1.88-27.19-4.11-39.53-10.95c-4.32-2.44-7.95-5.44-9.34-10.46c-0.07-2.09,0-4.18-0.07-6.28c0.07-0.98,0.07-2.16,0.07-2.16
			s1.39,0.28,2.3,1.32c3,3.49,6.83,5.72,11.02,7.6c12.83,5.86,26.49,8.09,40.37,9.55C259.88,558.06,266.99,558.48,273.97,558.97z"/>
		<path class="double_stripe" d="M441.72,566.78c-3.56,7.81-10.18,12.06-17.85,14.99c-12.41,4.67-25.52,5.58-38.49,6.62
			c-8.99,0.77-18.06,1.32-27.05,2.09c-0.84,0.07-2.37,0.21-2.37,0.21s0-1.46-0.07-2.44c-0.21-4.6-0.28-8.51-0.28-8.51
			s4.39-0.49,8.3-0.77c14.78-1.05,29.63-1.32,44.27-3.9c8.99-1.6,17.92-3.7,25.31-9.76c2.93-2.37,5.16-5.23,7.18-9.27
			c0.42,2.79,0.77,4.74,1.12,6.69C441.72,564.06,441.72,565.45,441.72,566.78z"/>
		<path class="double_stripe" d="M274.03,580.44c0,3.49,0,6.97,0,10.46c-0.56,0.07-1.32,0.28-1.88,0.21c-11.92-0.63-23.78-1.67-35.49-4.04
			c-10.67-2.16-21.2-5.02-30.19-11.57c-4.32-3.14-8.51-6.34-7.95-12.69c0.07-0.21,0.14-0.63,0.14-0.84c0.21-1.46,0.28-2.3,0.35-3.56
			c0-0.21-0.07-0.63,0-0.84c0.91-0.14,1.53,0.56,2.09,1.32c3.97,5.37,9.27,8.85,15.41,11.36c9.27,3.77,18.83,6,28.66,7.6
			C254.72,579.33,264.48,579.61,274.03,580.44z"/>
		<path class="double_stripe" d="M57.26,563.71c5.02,0.77,9.83,2.44,14.85,3.07c13.11,1.6,26.08,1.46,38.56-3.56
			c0.42-0.14,0.91-0.14,1.39-0.21c-0.63,3.83-1.32,7.67-1.95,11.5c-4.67,2.86-10.04,3.35-15.27,3.9
			c-11.92,1.32-23.78,1.39-35.35-2.23C58.66,572.08,57.96,567.89,57.26,563.71z"/>
		<path class="double_stripe" d="M584.58,573.82c-2.93,2.44-6.48,2.93-10.04,3.35c-11.92,1.46-23.78,1.32-35.49-1.74
			c-1.53-0.42-3-1.19-4.53-1.74c-0.7-3.83-1.32-7.6-2.02-11.43c4.32,0.56,8.44,2.3,12.76,3c12.83,2.23,25.52,1.88,38.07-1.88
			c0.91-0.28,1.81-0.35,2.72-0.49C585.49,566.57,585.07,570.2,584.58,573.82z"/>
		<path class="double_stripe" d="M59.22,596.83c0-3.42,0.07-6.83,0.07-10.25c2.3-0.91,4.25,0.77,6.34,1.05c14.5,2.3,28.8,2.16,43.02-2.93
			c0,3.42,0,6.69,0,10.04l0,0c-1.6,1.39-3.49,2.3-5.51,2.72c-11.85,2.86-23.85,4.04-35.98,2.23
			C64.38,599.27,61.24,599.34,59.22,596.83z"/>
		<path class="double_stripe" d="M582.49,596.06c-6.48,3.28-13.46,3.42-20.36,3.07c-6.9-0.35-13.88-0.91-20.57-2.79
			c-2.16-0.63-5.3-0.91-5.86-3.14c-0.77-3.07-0.49-6.41-0.28-9.69c0.07-1.26,1.26-0.35,1.88-0.14c13.46,4.88,27.12,5.3,41.07,2.72
			c1.67-0.28,3.14-1.53,4.95-1.12l0,0c0,0.7,0,1.39,0,2.09C583.05,590.07,582.77,593.06,582.49,596.06z"/>

	
		<path class="double_stripe" d="M350.03,138.82c0.56-5.44,2.23-10.6,3.9-15.69c5.09-15.76,9.27-31.86,14.85-47.48
			c0.35-1.05,0.42-2.3,1.46-3.07c0.91,1.46,1.74,2.86,2.65,4.32c-0.07,2.09-0.14,4.11-0.63,6.21c-4.32,18.06-8.72,36.05-15.55,53.34
			C354.43,137.28,352.2,138.05,350.03,138.82z"/>		
		
		<path class="double_stripe" d="M371.37,124.66c-2.51,3.35-4.95,6.69-8.79,8.65c0-0.35-0.14-0.7,0-1.05c5.72-15.13,9.48-30.82,12.48-46.65
			c0.14-0.7,0.49-0.98,1.19-0.98c0.91,2.09,1.81,4.11,2.72,6.21c0,2.93-0.42,5.72-1.19,8.51
			C375.55,107.79,373.46,116.22,371.37,124.66z"/>

		<path class="double_stripe" d="M287.6,135.5c-1.2-0.3-2.4-0.7-3.6-1.1c-0.9-0.3-1.8-0.7-2.7-1.1c-7.7-17.3-14.1-34.4-19.3-52.7  c1-2.3,2.1-4.5,3.3-6.7c0.3-0.5,0.6-1.1,0.9-1.6c0.2-0.4,0.5-0.8,0.7-1.2c0,0,0,0.1,0,0.1c3.6,17.7,9.4,34.2,15.7,51  C284.4,127,286.7,130.7,287.6,135.5z"/>

		<path class="double_stripe" d="M277,131.1c-1.1-0.6-2.2-1.3-3.3-2c-2.2-1.4-4.3-3-6.3-4.7c-4-8.7-7.2-17.3-10.1-26.5c-0.4-1.3-0.8-2.7-1.1-4.1  c0.9-2,1.7-3.9,2.5-5.9c0.3-0.8,0.7-1.6,1-2.3C264,101.7,269.4,116.1,277,131.1z"
			/>
	</g>
	<g id="jacket-regular.psd_2_">
		<image style="overflow:visible;enable-background:new;" class="ms-filter" width="584" height="568" id="jacket-regular" xlink:href="https://www.customvarsityapparel.com.au/customize/img/jacket_design/jacket_front.png" transform="matrix(1.0257 0 0 1.0257 20.839 44.6119)">
		</image>
	</g>
	<g>
	<path class="button" d="M322.9,426.2c2.9,0.1,5.6,2.9,5.4,5.7c-0.1,2.9-3,5.4-5.9,5.2s-5.2-2.6-5.2-5.5   C317.3,428.7,320,426.1,322.9,426.2z"/>
	<path class="button" d="M323.7,559.2c0.1,2.9-2.6,5.6-5.5,5.6s-5.6-2.8-5.6-5.6c0.1-2.7,2.6-5.3,5.4-5.4   C321,553.6,323.7,556.3,323.7,559.2z"/>
	<path class="button" d="M321.7,238c2.9,0,5.6,2.6,5.5,5.6c0,2.9-2.8,5.5-5.6,5.4c-2.7-0.1-5.4-2.7-5.4-5.4   C316,240.8,318.8,238,321.7,238z"/>
	<path class="button" d="M326.5,336.8c0,3.1-2.6,5.6-5.6,5.5c-2.9-0.1-5.2-2.5-5.3-5.4c-0.1-3,2.5-5.6,5.6-5.5   C324.2,331.5,326.5,333.8,326.5,336.8z"/>
	<path class="button" d="M317.5,580.2c2.9,0,5.6,2.7,5.5,5.5c0,2.7-2.7,5.4-5.4,5.4c-2.9,0.1-5.6-2.6-5.7-5.4   C311.8,582.9,314.5,580.2,317.5,580.2z"/>
	<path class="button" d="M324.7,521.2c0,3.1-2.5,5.4-5.6,5.4c-3-0.1-5.3-2.4-5.3-5.3c0-3.1,2.4-5.4,5.6-5.3   C322.5,516,324.7,518.3,324.7,521.2z"/>
	<path class="button" d="M350.1,154.1c-0.1,2.9-2.6,5.1-5.6,5c-2.9-0.1-5.2-2.5-5.2-5.3c0.1-3.2,2.4-5.3,5.6-5.2   C347.9,148.8,350.2,151.2,350.1,154.1z"/>
	</g>
</g>
</svg>

<!-- left chest customization  -->
<div data-hidden="" v-show="leftChest_id === 'leftChest_letters'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-l">
	<svg class="ms-main-holder leftChest_letters_holder">
		<text dominant-baseline="central" text-anchor="middle" dx="0, -1, -1" dy="-20, 40, 40" y="50%" x="50%" class="leftChest_letters">
			{{leftChest_letters}}
		</text>
	</svg>
</div>
<div data-hidden="" v-show="leftChest_id === 'leftChest_years'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-l">
	<svg class="ms-main-holder leftChest_years_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="leftChest_years">
			{{leftChest_years}}
		</text>
	</svg>
</div>
<div data-hidden="" v-show="leftChest_id === 'leftChest_logos'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-l">
	<img :src="leftChest_logos" alt="" class="leftChest_logos">
</div>
<!-- right chest customization Ends -->

<!-- right chest customization Starts  -->
<div v-show="rightChest_id === 'rightChest_letters'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-2">
	<svg class="ms-main-holder rightChest_letters_holder">
		<text dominant-baseline="central" text-anchor="middle" dx="0, -1, -1" dy="-20, 40, 40" y="50%" x="50%" class="rightChest_letters">
		{{rightChest_letters}}
		</text>
	</svg>
</div>

<div v-show="rightChest_id === 'rightChest_name'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-2">
	<svg class="ms-main-holder rightChest_name_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="rightChest_name">
		{{rightChest_name}}
		</text>
	</svg>
</div>

<div v-show="rightChest_id === 'rightChest_years'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-2">
	<svg class="ms-main-holder rightChest_years_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="rightChest_years">
			{{rightChest_years}}
		</text>
	</svg>
</div>
<div data-hidden="" v-show="rightChest_id === 'rightChest_logos'" class="ms-custom-box ms-jacket-box-front ms-jacket--front-2">
	<img :src="rightChest_logos" alt="" class="rightChest_logos">
</div>
<!-- right chest customization Ends -->

</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	name: 'Jacket',
	created() {
		this.$store.watch( getters => getters.leftChest_id)
		this.$store.watch( getters => getters.leftChest_letters)
		 this.$store.watch( getters => getters.leftChest_letters_fontfamily)
		this.$store.watch( getters => getters.leftChest_years)
		this.$store.watch( getters => getters.leftChest_logos)

		this.$store.watch( getters => getters.rightChest_id)
		this.$store.watch( getters => getters.rightChest_letters)
		this.$store.watch( getters => getters.rightChest_name)
		this.$store.watch( getters => getters.rightChest_years)
		this.$store.watch( getters => getters.rightChest_logos)
	},
	computed: {
		...mapGetters({
			leftChest_id: 'leftChest_id',
			leftChest_letters: 'leftChest_letters',
			leftChest_letters_fontfamily: 'leftChest_letters_fontfamily',
			leftChest_years: 'leftChest_years',
			leftChest_logos: 'leftChest_logos',
			rightChest_id: 'rightChest_id',
			rightChest_letters: 'rightChest_letters',
			rightChest_name: 'rightChest_name',
			rightChest_years: 'rightChest_years',
			rightChest_logos: 'rightChest_logos',
			
		}),
	}
}
</script>
<style scoped>

.body{fill: transparent;}
.sleeve{fill:transparent;}
.solid{fill:transparent;}
.pocket{fill:transparent;}
.button{fill:transparent;}
.single_stripe{fill:transparent;}
.double_stripe{fill:transparent;}
.ms-filter{mix-blend-mode: multiply;}

/* custom */

.ms-jacket--front-l {
    left: 57%;
}
.ms-jacket--front-2 {
    right: 58%;
}
.ms-jacket-box-front {
    padding-bottom: 10%;
    top: 30.5%;
    width: 10%;
}

.ms-custom-box {
    position: absolute;
    z-index: 1;
}
.ms-main-holder {
    left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
	-webkit-text-stroke: 5px transparent;
}

.leftChest_letters_holder {
    font-size: 4.5em;
	font-family: 'Athletic', sans-serif;
}
.leftChest_years_holder {
    font-size: 2.5em;
	font-family: 'Athletic', sans-serif;
}

.leftChest_letters {
	display: none;
 	fill: #000;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: transparent;	
}
.leftChest_years {
	display: none;
 	fill: #fff;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: #000;	
}
.leftChest_logos {
 	display: none;
	width: 100%;		
}


.rightChest_letters_holder {
    font-size: 4.5em;
	font-family: 'Athletic', sans-serif;
}
.rightChest_years_holder {
    font-size: 2.5em;
	font-family: 'Athletic', sans-serif;
}
.rightChest_letters {
	display: none;
 	fill: #000;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: transparent;	
}


.rightChest_name_holder {
    font-size: 1em;
	font-family: 'Athletic', sans-serif;
}

.rightChest_name {
	display: none;
 	fill: #000;	
}

.rightChest_years{
	display: none;
 	fill: #fff;
  	stroke-width: 8px;
  	paint-order: stroke;
  	stroke: #000;	
}
.rightChest_logos {
 	display: none;
	 width: 100%;		
}

</style>